(function () {
  if (!window.RIWAYAT || !window.RIWAYAT.soundEnabled) return;

  // Sound is always on — no toggle button, nothing to persist. A short synthesized
  // tone (Web Audio oscillator, not a media file) plays on interactive clicks. The
  // AudioContext is created lazily on the first real click, which both satisfies
  // every browser's "needs a user gesture" audio policy and avoids doing any audio
  // work before it's actually needed.
  var ctx = null;

  function ensureContext() {
    if (!ctx) {
      var AudioCtx = window.AudioContext || window.webkitAudioContext;
      if (!AudioCtx) return null;
      ctx = new AudioCtx();
    }
    if (ctx.state === 'suspended') ctx.resume();
    return ctx;
  }

  function drop(frequency, duration) {
    var audioCtx = ensureContext();
    if (!audioCtx) return;

    var osc = audioCtx.createOscillator();
    var gain = audioCtx.createGain();
    osc.type = 'sine';
    osc.frequency.setValueAtTime(frequency, audioCtx.currentTime);
    osc.frequency.exponentialRampToValueAtTime(frequency * 0.55, audioCtx.currentTime + duration);
    gain.gain.setValueAtTime(0.0001, audioCtx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.08, audioCtx.currentTime + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, audioCtx.currentTime + duration);
    osc.connect(gain).connect(audioCtx.destination);
    osc.start();
    osc.stop(audioCtx.currentTime + duration + 0.05);
  }

  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!(target instanceof Element)) return;
    if (target.closest('.button, a, button')) drop(520, 0.22);
  });

  window.riwayatPlayDrop = function () {
    drop(440, 0.4);
  };
})();
